import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { useAppDispatch, useAppSelector } from "flight-react/hooks/reduxHooks";
import moment from "moment";
import { RootState } from "redux/store";

const validateCartTTL = () => {
  const cartId = localStorage.getItem("cartId");
  if (!cartId) return null;

  let cartId_ttl = localStorage.getItem("cartId_ttl");
  if (cartId_ttl) {
    if (moment().add(-1, "hour").isAfter(cartId_ttl)) {
      localStorage.removeItem("cartId");
      localStorage.removeItem("cartId_ttl");
      return null;
    }
  } else {
    localStorage.removeItem("cartId");
    localStorage.removeItem("cartId_ttl");
    return null;
  }
  return Number(cartId);
};

const initialState: {
  cartId: number | null;
  showMarkUpPrice: boolean;
} = {
  cartId: validateCartTTL(),
  showMarkUpPrice: true,
};

export const ActivityCartSlice = createSlice({
  name: "ActivityCart",
  initialState,
  reducers: {
    toggleMarkUpView: (state) => {
      state.showMarkUpPrice = !state.showMarkUpPrice;
    },
    setCartId: (state, action: PayloadAction<number | null>) => {
      state.cartId = action.payload;

      if (action.payload) {
        localStorage.setItem("cartId_ttl", moment().toString());
        localStorage.setItem("cartId", String(action.payload));
      } else {
        localStorage.removeItem("cartId");
        localStorage.removeItem("cartId_ttl");
      }
    },
  },
});

export const useActivityCartSlice = () => {
  const { cartId, showMarkUpPrice } = useAppSelector(
    (value) => value.activityCart
  );
  const dispatch = useAppDispatch();

  const toggleMarkUpView = () =>
    dispatch(ActivityCartSlice.actions.toggleMarkUpView());
  const setCartId = (cartId: number | null) =>
    dispatch(ActivityCartSlice.actions.setCartId(cartId));

  return {
    toggleMarkUpView,
    setCartId,
    cartId,
    showMarkUpPrice,
  };
};

export const selectActivityCartSlice = (state: RootState) => {
  return state.searchFlight;
};

export const activityCartActions = ActivityCartSlice.actions;
export default ActivityCartSlice.reducer;
